import { useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Lock, User as UserIcon, AlertCircle } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const from = (loc.state as { from?: Location } | null)?.from?.pathname || "/";

  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    const r = await login(u.trim(), p);
    setLoading(false);
    if (!r.ok) {
      setErr(r.error || "登录失败");
      return;
    }
    nav(from, { replace: true });
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-surface to-brand-light px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="mb-10 flex items-center justify-center gap-2">
          <img src="/logo-icon.png" alt="Mediversity" className="h-12 w-12 object-contain" />
          <div className="leading-tight">
            <div className="font-display text-lg font-semibold text-ink-900">Mediversity</div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-ink-400">Video Platform</div>
          </div>
        </Link>

        <div className="rounded-2xl bg-white p-8 shadow-card md:p-10">
          <h1 className="font-display text-2xl font-semibold text-ink-900">登录</h1>
          <p className="mt-1 text-sm text-ink-400">仅限内部学员访问。如需账号请联系管理员。</p>

          <form onSubmit={submit} className="mt-7 space-y-4">
            <label className="block">
              <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-ink-600">
                用户名
              </span>
              <div className="relative">
                <UserIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-400" />
                <input
                  className="input pl-9"
                  placeholder="username"
                  value={u}
                  onChange={(e) => setU(e.target.value)}
                  autoComplete="username"
                  required
                />
              </div>
            </label>

            <label className="block">
              <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-ink-600">
                密码
              </span>
              <div className="relative">
                <Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-400" />
                <input
                  className="input pl-9"
                  type="password"
                  placeholder="••••••••"
                  value={p}
                  onChange={(e) => setP(e.target.value)}
                  autoComplete="current-password"
                  required
                />
              </div>
            </label>

            {err && (
              <div className="flex items-center gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
                <AlertCircle className="h-4 w-4 shrink-0" />
                {err}
              </div>
            )}

            <button type="submit" disabled={loading} className="btn-primary w-full">
              {loading ? "登录中…" : "登录"}
            </button>
          </form>
        </div>

        <div className="mt-6 text-center text-[11px] text-ink-400">
          沪ICP备2025138775号-3 · © 2026 海千蓦信息咨询有限公司
        </div>
      </div>
    </div>
  );
}
